import { render, staticRenderFns } from "./DocumentWarehouseState.vue?vue&type=template&id=c8a6b608&scoped=true"
import script from "./DocumentWarehouseState.vue?vue&type=script&lang=js"
export * from "./DocumentWarehouseState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a6b608",
  null
  
)

export default component.exports